import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./Clientes.css";
import axios from "axios";
import { LocalData } from "../../Componentes/Util/LocalData";
import { Key } from "react-bootstrap-icons";

export default function Clientes() {
    const [produtos, setProdutos] = useState([]);
    const [Prod, setProd] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0)
    const [localdataPROD, setLocaldataPROD] = useState("");
    const [cabecalho, setCabecalho] = useState();

    useEffect(() => {
    const fetchClientes = async () => {
    $("#objCarregaTela").addClass("display-block");  
    try{
    //LocalData.set("prodID",[]);
    if(LocalData.get("prodID") !== "")
        setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
    }catch(e){}

        const response = await axios.get("https://api.construmarcas.com.br/api/produtos/!!CLIENTES!!");
        setProdutos(response.data);

    $("#objCarregaTela").removeClass("display-block");
    };

    fetchClientes();
    }, [LocalData.get("prodID")]);

    const evCliqueProduto = (e) =>
    {
    $(".area-produto").addClass("produto-selecionado");
    $(".area-impressao-produto").removeClass("selecionado");

    let p = produtos.find((produto) => {
        try {
        return JSON.parse(parseInt(JSON.parse(produto.dados).id) === parseInt($(e.currentTarget).attr("id")));
        } catch (error) {
        return null;
        }
    });
    //console.log(p.dados);
    let __prod = {...p, ...{indexBanner: 0}};
    //console.log("__prod", __prod);
    setProd([__prod]);
    setActiveIndex(0);

    $("body").addClass("overflow-hidden");
    }

    return (
        <div className="conteudo conteudo-clientes">
        <h3>Clientes</h3>
        <br />
            {
                produtos.map((cliente, index) => {
                    let dados = JSON.parse(cliente.dados);
                    console.log("dados", dados);
                    return (
                        <div key={index} className="area-produto-cliente">
                            <div className="capa" id={dados.id}>
                                {
                                    dados.anexos.map((anexo, idx) => {
                                        if(anexo.tipo === "imagem" || anexo.tipo === "jpg" || anexo.tipo === "png" || anexo.tipo === "jpeg"){
                                            return <div><img key={idx} src={anexo.url} /></div>
                                        }
                                    })
                                }
                            </div>
                            {/* <h2>{dados.nome.split("!!EV!!")[1]}</h2> */}
                        </div>
                                
                        // <div key={index} className="capa" id={dados.id} onClick={evCliqueProduto}>
                        //     {
                        //         (dados.anexos.length > 0 && dados.anexos[0] !== null && dados.anexos[0] !== "null" && dados.anexos[0] !== "undefined")
                        //         ? <img src={dados.anexos[0].url} />
                        //         : null
                        //     }
                        //     <p>
                        //     <h2>{dados.nome.split("!!EV!!")[1]}</h2>
                        //     {
                        //         dados.seo.description
                        //     }
                        //     </p>
                        // </div>
                    );
                    })
            }
        </div>
    )
}